import { api } from "@/services/api";
import type { UserRole } from "@/store/authSlice";

export interface LoginRequest {
  emailAddress: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  role: UserRole;
  user: {
    id: number;
    emailAddress: string;
    role: UserRole;
    firstName?: string;
    lastName?: string;
    clientId?: number;
  };
}

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (body) => ({
        url: "/auth/login",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Auth"],
    }),
    requestPasswordReset: builder.mutation<{ message: string }, { email: string }>({
      query: (body) => ({
        url: "/auth/password-reset/request",
        method: "POST",
        body,
      }),
    }),
    validateResetToken: builder.query<{ valid: boolean; message?: string }, string>({
      query: (token) => `/public/auth/password-reset/verify?token=${token}`,
    }),
    resetPassword: builder.mutation<{ message: string }, { token: string; password: string }>({
      query: (body) => ({
        url: "/public/auth/password-reset/reset",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { 
  useLoginMutation, 
  useRequestPasswordResetMutation,
  useValidateResetTokenQuery,
  useResetPasswordMutation
} = authApi;
